import React from 'react'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'

const SkipLinksTarget = (props) => {
  const { fields, params, sitecoreContext, t } = props
  const isEditing = sitecoreContext && sitecoreContext.pageEditing

  if (isEditing) {
    return true
  }

  return <div id="main-content"></div>
}

export default withSitecoreContext()(withTranslation()(SkipLinksTarget))
